module.exports = __webpack_public_path__ + "img/常宁市妇幼保健院.674a81ca.png";